import { render, staticRenderFns } from "./BillOfMaterials.vue?vue&type=template&id=3fb04818&scoped=true&"
import script from "./BillOfMaterials.vue?vue&type=script&lang=js&"
export * from "./BillOfMaterials.vue?vue&type=script&lang=js&"
import style0 from "./BillOfMaterials.vue?vue&type=style&index=0&id=3fb04818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb04818",
  null
  
)

export default component.exports